var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "photo_svg__icon photo_svg__icon-tabler photo_svg__icon-tabler-photo",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 8h.01"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 16,
  height: 16,
  rx: 3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m4 15 4-4a3 5 0 0 1 3 0l5 5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m14 14 1-1a3 5 0 0 1 3 0l2 2"
})));
export default SvgPhoto;